import React from 'react';
import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { ShieldOff } from 'lucide-react';

const AccessDenied = ({
    title = 'Access Denied',
    description = "You don't have permission to view this page.",
    showBack = true,
}) => {
    const navigate = useNavigate();

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}>
            <Result
                icon={<ShieldOff size={48} color="var(--warning)" strokeWidth={1.5} />}
                title={title}
                subTitle={description}
                extra={showBack && (
                    <Button type="primary" onClick={() => navigate('/')}>
                        Back to Dashboard
                    </Button>
                )}
            />
        </div>
    );
};

export default AccessDenied;
